/**
 * One-shot bootstrap hand-off.
 *
 * Fires `window.__assistentusReady()` exactly once when called with
 * `ready=true`. The HTML #boot-splash (index.html) listens for that
 * callback and fades itself out. Every top-level panel (chat, notes,
 * tasks, login) calls this hook so the splash covers each route's first
 * meaningful paint — without us having to centralise a "is everything
 * loaded yet" predicate.
 */

import { useEffect } from 'react';

let _fired = false;

export function signalBootReady(): void {
  if (_fired) return;
  _fired = true;
  try {
    const fn = (window as unknown as { __assistentusReady?: () => void }).__assistentusReady;
    if (typeof fn === 'function') fn();
  } catch {
    /* noop */
  }
}

export function useBootReady(ready: boolean): void {
  useEffect(() => {
    if (ready) signalBootReady();
  }, [ready]);
}
